module.exports = __webpack_public_path__ + "static/media/MR.c8a9cbaa.png";